import { data } from 'react-router'

import { getRequestIdFromError } from 'utils/errors'

export function pageErrorData (
  error: unknown,
  options: { heading?: string; message?: string } = {}
) {
  return data({
    heading: options.heading,
    message: options.message,
    requestId: getRequestIdFromError(error),
  })
}
